__turbopack_context__.v({
  "link": "_0cRMVG_link",
});
